import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import * as labs from 'vuetify/labs/components';

const customTheme = {
  dark: false,
  colors: {
    primary: '#5c3189'
  }
}

const customThemeDark = {
  dark: true,
  colors: {
    primary: '#5c3189'
  }
}

export default createVuetify({
  components: {
    ...components,
    ...labs
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
      customThemeDark
    }
  }
})